/* eslint-disable */
import Cookies from 'universal-cookie'
import isBrowser from 'utils/isBrowser'
import domainName from 'utils/domainName'
import getCurrentUrl from 'utils/url'

const FULLSCREEN_PLACEMENT_REQUESTED_COOKIE_NAME = 'fullscreenscroll'
const cookies = new Cookies()

const getFullscreenLimitCookie = (placementId) => {
  if (!isBrowser()) {
    return false
  }

  return !!cookies.get(FULLSCREEN_PLACEMENT_REQUESTED_COOKIE_NAME)
}

const setFullscreenLimitCookie = (placementId) => {
  if (!isBrowser()) {
    return
  }

  if (placementId !== 'panorama_device_2') {
    return
  }

  console.debug('Setting cookie for ', placementId)

  const cookieOptions = {
    path: '/',
    secure: false,
    httpOnly: false,
    maxAge: 4 * 60 * 60, // 4 hours
    domain: `.${domainName.getRootDomain(getCurrentUrl())}`,
  }

  if (!getFullscreenLimitCookie()) {
    cookies.set(FULLSCREEN_PLACEMENT_REQUESTED_COOKIE_NAME, true, cookieOptions)
  }
}

export { setFullscreenLimitCookie, getFullscreenLimitCookie }
